export default __webpack_public_path__ + "static/media/megha.bb6591fe.png";